<template>
  <ion-page>
    <main-header>
      <ion-toolbar>
        <ion-searchbar inputmode="search" @ionChange="search"></ion-searchbar>
      </ion-toolbar>
    </main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
          <ion-fab-button color="success" @click="handleAdd()">
            <ion-icon name="add"></ion-icon>
          </ion-fab-button>
        </ion-fab>
        <div
          v-if="!locations.length"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no locations available.
        </div>
        <div
          v-else-if="!filteredLocations.length"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no locations found.
        </div>
        <div v-else>
          <ion-list>
            <ion-item
              v-for="location in filteredLocations"
              v-bind:key="`location-${location.id}`"
              detail="true"
              button
              @click="navigateToLocation(location.id)"
              :data-cy="`location-${location.id}`"
            >
              <ion-avatar slot="start">
                <img :src="location.photoURL" />
              </ion-avatar>
              <ion-label>
                <h2>
                  {{ location.name }}
                </h2>
                <h3>{{ location.city }}, {{ location.state }}</h3>
              </ion-label>
              <ion-badge v-if="!location.acceptingOrders" color="danger">
                Not Accepting Orders
              </ion-badge>
            </ion-item>
          </ion-list>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
/**
 * A lot of similarities in this component to something like user list
 */
import errorAlert from "@/ErrorAlert";
import Location from "@/models/Location";
import { mapGetters } from "vuex";

export default {
  title: "Locations",
  data: function() {
    return {
      loading: true,
      locations: [],
      searchTerm: ""
    };
  },

  methods: {
    search(event) {
      this.searchTerm = event.detail.value;
    },

    navigateToLocation(id) {
      this.$router.push({
        name: "Web: Location Edit",
        params: {
          id
        }
      });
    },

    handleAdd() {
      this.$router.push({
        name: "Web: Location Add"
      });
    }
  },

  created() {
    if (!this.userIsAdmin) {
      return this.$router.push("/").catch(e => e);
    }

    this.$firestore()
      .collection("locations")
      .withConverter(Location.firebaseConverter)
      .orderBy("name")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.locations.push(doc.data());
        });
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {
    filteredLocations() {
      let filtered = this.locations;

      if (this.searchTerm) {
        let term = this.searchTerm.toLowerCase();

        filtered = filtered.filter(
          location =>
            location.name.toLowerCase().indexOf(term) > -1 ||
            location.city.toLowerCase().indexOf(term) > -1
        );
      }

      return filtered;
    },

    ...mapGetters("auth", ["userIsAdmin"])
  }
};
</script>

<style lang="scss" scoped>
// this is because it tends to scroll up with a lot of locations
ion-fab {
  position: fixed;
  right: 24px;
}
</style>
